import {
  GET_SALARY_RANGES_ERROR,
  GET_SALARY_RANGES_START,
  GET_SALARY_RANGES_SUCCESS,
  INITIALIZE_WITH_JOB,
  RESET_SAVE_JOB_PRICING_TO_INITIAL_STATE,
  SAVE_ORG_JOB_FAILED,
  SAVE_ORG_JOB_START,
  SAVE_ORG_JOB_SUCCESS,
  SET_CAREER_LEVEL,
  SET_CURRENCY,
  SET_EEO_JOB_CATEGORY,
  SET_EEO_JOB_GROUP,
  SET_FLSA_EXEMPT,
  SET_JOB_DESCRIPTION,
  SET_JOB_FAMILY,
  SET_JOB_TITLE,
  SET_ORG_JOB_CODE,
  SET_ORG_JOB_CODE_KEY,
  SET_ORG_JOB_DETAILS,
  SET_SALARY_RANGE,
  SET_SELECTED_USER_DEFINED_FIELDS,
  SET_TARGET_BASE_SALARY,
  SET_TARGET_TOTAL_CASH,
  SET_TARGET_TOTAL_DIRECT,
  SET_TARGET_TOTAL_GUARANTEED_PAY,
  SET_TARGET_TOTAL_TARGET_CASH,
  SET_YEARS_OF_EXPERIENCE,
  SET_SALARY_RANGE_MIN,
  SET_SALARY_RANGE_MID,
  SET_SALARY_RANGE_MAX
} from './SaveJobPricingActions';
import cloneDeep from 'lodash/cloneDeep';
import { isAdHocJobId } from '../helper';

const orgJobDetailsInitialState = {
  orgJobTitle: '',
  jobDetails: {}
};

const initialState = {
  currency: null,
  isCurrencyLoading: false,
  salaryRange: null,
  isSalaryRangesLoading: false,
  careerLevel: null,
  jobFamily: null,
  jobTitle: '',
  orgJobCode: '',
  orgJobCodeKey: '',
  jobDescription: '',
  yearsOfExperience: '',
  targetTotalCash: '50th',
  targetBaseSalary: '50th',
  targetTotalTargetCash: '50th',
  targetTotalGuaranteedPay: '50th',
  targetTotalDirect: '50th',
  flsaExempt: '',
  eeoJobGroup: '',
  eeoJobCategory: '',
  isSaving: false,
  isSaveFailed: false,
  isSaved: false,
  orgJobId: null,
  orgJobDetails: cloneDeep(orgJobDetailsInitialState),
  hasSalaryRangesError: false,
  isDuplicateError: false,
  isSalaryRangesLoaded: false,
  isInitialized: false,
  salaryRanges: [],
  skills: [],
  certifications: [],
  selectedUserDefinedFields: [],
  salaryRangeMin: '',
  salaryRangeMid: '',
  salaryRangeMax: ''
};

export const BASE_MARKET_TARGET_OPTIONS = ['10th', '25th', '50th', '60th', '65th', '75th', '90th', 'avg'];

export const FULL_MARKET_TARGET_OPTIONS = [
  '10th',
  '25th',
  '50th',
  '60th',
  '60th_interp',
  '62_5th',
  '65th',
  '65th_interp',
  '75th',
  '90th',
  'avg'
];

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case INITIALIZE_WITH_JOB: {
      if (action.job) {
        const isAdHocJob = isAdHocJobId(action.job.id);

        if (isAdHocJob) {
          return {
            ...state,
            isInitialized: true
          };
        }

        const job = action.job;

        if (job.jobDetails) {
          if (job.jobDetails.Skills) {
            job.jobDetails.SkillNameList = job.jobDetails.Skills.map(skill => skill.answer);
          }
          if (job.jobDetails.Certifications) {
            job.jobDetails.CertNameList = job.jobDetails.Certifications.map(cert => cert.answer);
          }
        }

        const orgJobDetails = {
          orgJobTitle: job.title,
          jobDetails: cloneDeep(job.jobDetails) || {}
        };

        const selectedUserDefinedFields = job.userDefinedFields.filter(
          field => field.inputValue !== undefined && field.inputValue !== null
        );

        return {
          ...state,
          salaryRange: job.salaryRange,
          careerLevel: job.level,
          jobFamily: job.family,
          jobTitle: job.title,
          orgJobCode: job.code,
          orgJobCodeKey: job.codeKey,
          jobDescription: job.description,
          yearsOfExperience: job.jobDetails?.YearsExperience,
          targetTotalCash: job.targetTotalCash,
          targetBaseSalary: job.targetBaseSalary,
          targetTotalTargetCash: job.targetTotalTargetCash,
          targetTotalGuaranteedPay: job.targetTotalGuaranteedPay,
          targetTotalDirect: job.targetTotalDirect,
          flsaExempt: job.flsaExempt,
          eeoJobGroup: job.eeoJobGroup,
          eeoJobCategory: job.eeoJobCategory,
          orgJobId: job.id,
          orgJobDetails,
          selectedUserDefinedFields,
          isInitialized: true,
          salaryRangeMin: job.salaryRange?.salaryMinimum?.toString(),
          salaryRangeMid: job.salaryRange?.salaryMidpoint?.toString(),
          salaryRangeMax: job.salaryRange?.salaryMaximum?.toString()
        };
      }
    }
    case GET_SALARY_RANGES_START: {
      return {
        ...state,
        isSalaryRangesLoading: true,
        isSalaryRangesLoaded: false
      };
    }
    case GET_SALARY_RANGES_SUCCESS: {
      return {
        ...state,
        salaryRanges: action.salaryRanges,
        isSalaryRangesLoading: false,
        isSalaryRangesLoaded: true
      };
    }
    case SET_CURRENCY: {
      return {
        ...state,
        currency: action.currency
      };
    }
    case SET_SALARY_RANGE: {
      return {
        ...state,
        salaryRange: action.salaryRange
      };
    }
    case SET_CAREER_LEVEL: {
      return {
        ...state,
        careerLevel: action.careerLevel
      };
    }
    case SET_JOB_FAMILY: {
      return {
        ...state,
        jobFamily: action.jobFamily
      };
    }
    case SET_JOB_TITLE: {
      state.orgJobDetails.orgJobTitle = action.jobTitle;
      return {
        ...state,
        jobTitle: action.jobTitle
      };
    }
    case SET_ORG_JOB_CODE: {
      return {
        ...state,
        orgJobCode: action.orgJobCode
      };
    }
    case SET_JOB_DESCRIPTION: {
      return {
        ...state,
        jobDescription: action.jobDescription
      };
    }
    case SET_YEARS_OF_EXPERIENCE: {
      return {
        ...state,
        yearsOfExperience: action.yearsOfExperience
      };
    }
    case SET_TARGET_TOTAL_CASH: {
      return {
        ...state,
        targetTotalCash: action.targetTotalCash
      };
    }
    case SET_TARGET_BASE_SALARY: {
      return {
        ...state,
        targetBaseSalary: action.targetBaseSalary
      };
    }
    case SET_TARGET_TOTAL_TARGET_CASH: {
      return {
        ...state,
        targetTotalTargetCash: action.targetTotalTargetCash
      };
    }
    case SET_TARGET_TOTAL_GUARANTEED_PAY: {
      return {
        ...state,
        targetTotalGuaranteedPay: action.targetTotalGuaranteedPay
      };
    }
    case SET_TARGET_TOTAL_DIRECT: {
      return {
        ...state,
        targetTotalDirect: action.targetTotalDirect
      };
    }
    case SET_FLSA_EXEMPT: {
      return {
        ...state,
        flsaExempt: action.flsaExempt
      };
    }
    case SET_EEO_JOB_GROUP: {
      return {
        ...state,
        eeoJobGroup: action.eeoJobGroup
      };
    }
    case SET_EEO_JOB_CATEGORY: {
      return {
        ...state,
        eeoJobCategory: action.eeoJobCategory
      };
    }
    case SAVE_ORG_JOB_START: {
      return {
        ...state,
        isSaving: true
      };
    }
    case SAVE_ORG_JOB_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        isSaveFailed: false,
        isSaved: true,
        orgJobId: action.orgJobId
      };
    }
    case SAVE_ORG_JOB_FAILED: {
      return {
        ...state,
        isSaving: false,
        isSaveFailed: true,
        isDuplicateError: action.isDuplicateError === true
      };
    }
    case SET_ORG_JOB_CODE_KEY: {
      return {
        ...state,
        orgJobCodeKey: action.orgJobCodeKey
      };
    }
    case SET_ORG_JOB_DETAILS: {
      return {
        ...state,
        orgJobDetails: action.orgJobDetails
      };
    }
    case GET_SALARY_RANGES_ERROR: {
      return {
        ...state,
        hasGetSalaryRangesError: true
      };
    }
    case SET_SELECTED_USER_DEFINED_FIELDS: {
      return {
        ...state,
        selectedUserDefinedFields: action.userDefinedFields
      };
    }
    case RESET_SAVE_JOB_PRICING_TO_INITIAL_STATE: {
      return {
        ...initialState,
        orgJobDetails: cloneDeep(orgJobDetailsInitialState),
        salaryRanges: [],
        skills: [],
        certifications: [],
        selectedUserDefinedFields: []
      };
    }
    case SET_SALARY_RANGE_MIN: {
      return {
        ...state,
        salaryRangeMin: action.salaryRangeMin
      };
    }
    case SET_SALARY_RANGE_MID: {
      return {
        ...state,
        salaryRangeMid: action.salaryRangeMid
      };
    }
    case SET_SALARY_RANGE_MAX: {
      return {
        ...state,
        salaryRangeMax: action.salaryRangeMax
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
}
